export function setToken(token) {
  return localStorage.setItem("api_token", token);
}

export function setRole(value) {
  return localStorage.setItem("role", value);
}

export function getToken(key) {
  return localStorage.getItem(key);
}

export function removeToken(key) {
  return localStorage.removeItem(key);
}
